import { Injectable } from '@angular/core';

import { ApiRepositoryService } from '#repositories/api-repository/api-repository.service';
import { IntermediaryService, MS_DELAY } from '#services/intermediary/intermediary.service';
import { IRedemptionService } from './redemption.interface';
import {
  UserRedemptionCode,
  UserRedeemedCode,
  PostCodeVerificationRequest,
  UserRedemptionCodeResponse,
  PostCodeVerificationResponse,
} from '#models/subscription/user-redemption.model';
import { Subject, BehaviorSubject } from 'rxjs';
import { logger } from '#lib/logger';

@Injectable({
  providedIn: 'root',
})
export class RedemptionService implements IRedemptionService {
  path = 'verify-code';

  userRedemptionCodeLoading$ = new Subject<boolean>();
  userRedemptionCodeResponse$ = new BehaviorSubject<UserRedemptionCode | null>(null);

  postCodeVerificationLoading$ = new Subject<boolean>();
  postCodeVerificationResponse$ = new Subject<UserRedeemedCode | null>();

  constructor(
    private apiRepository: ApiRepositoryService,
    private intermediaryHandler: IntermediaryService
  ) {}

  async verifyUserRedemption(silent?: boolean): Promise<boolean> {
    try {
      if (!silent) {
        this.userRedemptionCodeLoading$.next(true);
      }

      const response = await this.apiRepository.get<UserRedemptionCodeResponse>({
        url: `${this.path}/user-redemption`,
      });

      this.userRedemptionCodeResponse$.next(response.details);

      logger.log(response.details, 'RedemptionService.checkUserRedemptionCode -> response');

      return response.details.userVerificationCode;
    } catch (error: unknown) {
      // The error will be silent.
      logger.log(error, 'RedemptionService.checkUserRedemptionCode -> error');

      this.userRedemptionCodeResponse$.next({ userVerificationCode: false });

      return false;
    } finally {
      this.userRedemptionCodeLoading$.next(false);
    }
  }

  postRedemptionCode(
    request: PostCodeVerificationRequest,
    nextFn?: (data: UserRedeemedCode | null) => void
  ) {
    this.intermediaryHandler.intermediary(
      {
        loading: this.postCodeVerificationLoading$,
        subject: this.postCodeVerificationResponse$,
        delay: MS_DELAY,
        nextFn,
      },
      async () => {
        const response = await this.apiRepository.post<
          PostCodeVerificationResponse,
          PostCodeVerificationRequest
        >(
          {
            url: this.path,
          },
          request
        );

        logger.log(response.details, 'RedemptionService.postRedemptionCode -> response');

        return response.details;
      }
    );
  }

  resetRedemption() {
    this.userRedemptionCodeResponse$.next(null);
    logger.log('completed', 'RedemptionService.resetRedemption');
  }
}
